import React, { useEffect, useRef } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

const Validation = ({
	isTouched,
	invalidFeedback,
	validFeedback,
	isTooltip,
}) => {
	const ref = useRef(null);

	useEffect(() => {
		if (isTooltip) {
			for (let i = 0; i < ref?.current?.parentNode.classList.length; i += 1) {
				if (['input-group'].includes(ref?.current?.parentNode.classList[i])) {
					ref?.current?.parentNode.parentNode.classList.add(
						'position-relative',
					);
				} else {
					ref?.current?.parentNode.classList.add('position-relative');
				}
			}
		}
	});

	if (isTouched && invalidFeedback) {
		return (
			<div
				className={classNames({
					'invalid-feedback': !isTooltip,
					'invalid-tooltip': isTooltip,
				})}
				ref={ref}
			>
				{invalidFeedback}
			</div>
		);
	}
	return (
		!invalidFeedback &&
		validFeedback && (
			<div
				className={classNames({
					'valid-feedback': !isTooltip,
					'valid-tooltip': isTooltip,
				})}
				ref={ref}
			>
				{validFeedback}
			</div>
		)
	);
};
Validation.propTypes = {
	isTouched: PropTypes.bool,
	invalidFeedback: PropTypes.string,
	validFeedback: PropTypes.string,
	isTooltip: PropTypes.bool,
};
Validation.defaultProps = {
	isTouched: false,
	invalidFeedback: null,
	validFeedback: null,
	isTooltip: false,
};

export default Validation;
